const FIRST_NAMES = [
  'Maria', 'James', 'Sarah', 'David', 'Emily', 'Michael', 'Rachel', 'Robert',
  'Linda', 'William', 'Jennifer', 'Richard', 'Patricia', 'Thomas', 'Barbara',
  'Daniel', 'Susan', 'Matthew', 'Karen', 'Anthony', 'Nancy', 'Christopher',
  'Lisa', 'Andrew', 'Betty', 'Joseph', 'Dorothy', 'Charles', 'Sandra', 'Mark',
  'Ashley', 'Steven', 'Margaret', 'Paul', 'Donna', 'Kevin', 'Carol', 'Brian',
  'Ruth', 'George', 'Sharon', 'Timothy', 'Michelle', 'Ronald', 'Laura',
  'Edward', 'Kathleen', 'Jason', 'Amy', 'Jeffrey',
];

const LAST_NAMES = [
  'Chen', 'Whitfield', 'Martinez', 'Johnson', 'Anderson', 'Thompson', 'Garcia',
  'Robinson', 'Clark', 'Lewis', 'Walker', 'Hall', 'Allen', 'Young', 'King',
  'Wright', 'Hill', 'Scott', 'Adams', 'Baker', 'Nelson', 'Carter', 'Mitchell',
  'Perez', 'Roberts', 'Turner', 'Phillips', 'Campbell', 'Parker', 'Evans',
  'Edwards', 'Collins', 'Stewart', 'Morris', 'Reed', 'Cook', 'Morgan', 'Bell',
  'Murphy', 'Bailey', 'Rivera', 'Cooper', 'Richardson', 'Cox', 'Howard',
  'Ward', 'Torres', 'Peterson', 'Gray', 'Watson',
];

const PRACTICE_NAMES = [
  'Lakewood Primary Care', 'Summit Medical Group', 'Valley Health Associates',
  'Cedar Ridge Family Medicine', 'Riverside Medical Center', 'Maple Grove Clinic',
  'Evergreen Health Partners', 'Pinecrest Medical Associates', 'Beacon Hill Practice',
  'Clearwater Family Health', 'Harmony Medical Group', 'Oakdale Health Center',
  'Westside Primary Care', 'Northpoint Medical', 'Sunrise Health Partners',
  'Mountainview Clinic', 'Pacific Coast Medical', 'Heritage Family Practice',
  'Bayshore Health Group', 'Prairie Medical Associates', 'Crestview Health Center',
  'Harbor Medical Group', 'Meadowbrook Primary Care', 'Stonegate Family Medicine',
  'Bridgewater Health Partners', 'Fairview Medical Associates', 'Greenfield Clinic',
  'Crossroads Medical Group', 'Lakeshore Health Partners', 'Hillcrest Primary Care',
];

const FACILITY_NAMES = [
  'Memorial Regional Hospital', 'St. Joseph Medical Center', 'Community General Hospital',
  'Providence Health System', 'Good Samaritan Medical', 'Mercy Hospital',
  'United Health Center', 'Sacred Heart Hospital', 'Bayside Medical Center',
  'Summit Hospital', 'Northside Medical Center', 'Valley General Hospital',
  'Lakeview Regional', 'Trinity Health System', 'Riverside Community Hospital',
];

const PAYER_NAMES = [
  'Anthem Blue Cross', 'United Healthcare', 'Aetna', 'Cigna', 'Humana',
  'Kaiser Permanente', 'Blue Shield', 'Molina Healthcare', 'Centene',
  'WellCare', 'Magellan Health', 'Oscar Health', 'Bright Health',
];

const CONTRACT_NAMES = [
  'ACO REACH Global', 'ACO REACH Professional', 'MSSP Track 1+',
  'MSSP Enhanced Track', 'Direct Contracting Global', 'MA Value-Based',
  'Commercial Risk', 'Medicaid Managed Care', 'ACO REACH High Needs',
];

const STREET_NAMES = [
  'Oak', 'Maple', 'Cedar', 'Pine', 'Elm', 'Washington', 'Park', 'Lake',
  'Hill', 'Forest', 'River', 'Spring', 'Meadow', 'Sunset', 'Main',
];
const STREET_TYPES = ['St', 'Ave', 'Dr', 'Ln', 'Blvd', 'Ct', 'Rd', 'Way'];

const CITIES = [
  'Springfield', 'Riverside', 'Fairview', 'Georgetown', 'Madison',
  'Clinton', 'Franklin', 'Greenville', 'Bristol', 'Salem',
  'Manchester', 'Burlington', 'Ashland', 'Dayton', 'Oxford',
];

const STATES = [
  'AL', 'AZ', 'CA', 'CO', 'CT', 'FL', 'GA', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'MA', 'MD', 'MI', 'MN', 'MO', 'NC', 'NJ',
  'NM', 'NY', 'OH', 'OR', 'PA', 'SC', 'TN', 'TX', 'VA', 'WA',
];

const PHARMACY_NAMES = [
  'CVS Pharmacy', 'Walgreens', 'Rite Aid', 'Walmart Pharmacy',
  'Kroger Pharmacy', 'Costco Pharmacy', 'Publix Pharmacy',
  'Safeway Pharmacy', 'Target Pharmacy', 'HEB Pharmacy',
];

const TENANT_NAMES = [
  'Pinnacle Health Network', 'Atlas Care Partners', 'Meridian Health Alliance',
  'Vanguard Medical Group', 'Keystone Health Partners', 'Sterling Health Systems',
  'Compass Care Network', 'Summit Health Collaborative', 'Apex Medical Partners',
  'Horizon Care Alliance',
];

function djb2(str) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) + hash + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function pick(arr, seed) {
  return arr[seed % arr.length];
}

function spoofPhone(seed) {
  const area = 200 + (seed % 700);
  const mid = 200 + ((seed >> 8) % 700);
  const end = 1000 + ((seed >> 16) % 9000);
  return `(${area}) ${mid}-${end}`;
}

function spoofMbi(seed) {
  const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const digits = '0123456789';
  let mbi = '';
  const pattern = [digits, letters, letters, digits, letters, letters, digits, letters, letters, digits, digits];
  for (let i = 0; i < pattern.length; i++) {
    const pool = pattern[i];
    mbi += pool[(seed + i * 7) % pool.length];
  }
  return mbi;
}

function spoofNpi(seed) {
  let npi = '1';
  for (let i = 1; i < 10; i++) {
    npi += String((seed + i * 3) % 10);
  }
  return npi;
}

function spoofTin(seed) {
  const p1 = String(10 + (seed % 90));
  let p2 = '';
  for (let i = 0; i < 7; i++) {
    p2 += String((seed + i * 11) % 10);
  }
  return `${p1}-${p2}`;
}

function spoofSsn(seed) {
  const a = String(100 + (seed % 800));
  const b = String(10 + ((seed >> 8) % 90));
  const c = String(1000 + ((seed >> 16) % 9000));
  return `${a}-${b}-${c}`;
}

function spoofEmail(seed) {
  const first = pick(FIRST_NAMES, seed).toLowerCase();
  const last = pick(LAST_NAMES, seed >> 4).toLowerCase();
  const domains = ['gmail.com', 'yahoo.com', 'outlook.com', 'mail.com'];
  return `${first}.${last}@${pick(domains, seed >> 8)}`;
}

function spoofAddress(seed) {
  const num = 100 + (seed % 9900);
  const street = pick(STREET_NAMES, seed >> 4);
  const type = pick(STREET_TYPES, seed >> 8);
  const city = pick(CITIES, seed >> 12);
  const state = pick(STATES, seed >> 16);
  const zip = String(10000 + (seed % 90000));
  return `${num} ${street} ${type}, ${city}, ${state} ${zip}`;
}

function spoofZip(seed) {
  return String(10000 + (seed % 90000));
}

function spoofDate(seed) {
  const month = 1 + (seed % 12);
  const day = 1 + ((seed >> 4) % 28);
  const year = 1940 + ((seed >> 8) % 60);
  return `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
}

// --- Consistent name-token mapping ---
//
// A real name (e.g. "Ruth Kim") shows up in many places: the patient column as
// "Kim, Ruth", a provider cell as "Dr. Kim", and inside AI-generated narrative as
// "Ruth Kim was contacted...". To keep the demo coherent, every mention of a real
// name token must map to the SAME fake everywhere. We learn name tokens from the
// structured fields that clearly contain names, then substitute those tokens
// wherever they appear in free text.
const nameTokenMap = new Map(); // lowercase real token -> fake token
let nameTokenRegex = null;
let nameTokenDirty = false;
let nameMapVersion = 0;

function fakeForToken(token, role) {
  const key = token.toLowerCase();
  const existing = nameTokenMap.get(key);
  if (existing) return existing;
  const h = djb2(key);
  let fake;
  if (role === 'last') fake = pick(LAST_NAMES, h);
  else if (role === 'first') fake = pick(FIRST_NAMES, h);
  else fake = pick(h % 2 === 0 ? FIRST_NAMES : LAST_NAMES, h);
  nameTokenMap.set(key, fake);
  nameTokenDirty = true;
  nameMapVersion++;
  return fake;
}

function rebuildNameRegex() {
  nameTokenDirty = false;
  if (nameTokenMap.size === 0) {
    nameTokenRegex = null;
    return;
  }
  const keys = [...nameTokenMap.keys()]
    .sort((a, b) => b.length - a.length)
    .map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  nameTokenRegex = new RegExp('\\b(' + keys.join('|') + ')\\b', 'gi');
}

function applyNameTokens(text) {
  if (nameTokenDirty) rebuildNameRegex();
  if (!nameTokenRegex) return text;
  return text.replace(nameTokenRegex, (m) => {
    const fake = nameTokenMap.get(m.toLowerCase());
    if (!fake) return m;
    // Only substitute capitalized occurrences -- a lowercase match (e.g. "young",
    // "gray", "cook") is almost always a common word, not the person's name.
    if (m[0] === m[0].toLowerCase()) return m;
    if (m === m.toUpperCase() && m.length > 1) return fake.toUpperCase();
    return fake;
  });
}

function spoofPersonLastFirst(last, first) {
  return `${fakeForToken(last, 'last')}, ${fakeForToken(first, 'first')}`;
}

function spoofPersonFirstLast(first, last) {
  return `${fakeForToken(first, 'first')} ${fakeForToken(last, 'last')}`;
}

// --- Pattern detection ---

const PHONE_RE = /^[\s(]*\d{3}[\s).-]+\d{3}[\s.-]+\d{4}\s*$/;
const MBI_RE = /^[0-9][A-Z][A-Z0-9]{2}-?[A-Z0-9]{3}-?[A-Z0-9]{4}$/i;
const NPI_RE = /^[12]\d{9}$/;
const TIN_RE = /^\d{2}-\d{7}$/;
const SSN_RE = /^\d{3}-\d{2}-\d{4}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const DATE_RE = /^(\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}|\w{3}\s+\d{1,2},?\s+\d{4}|\d{4}-\d{2}-\d{2})$/;
const ZIP_RE = /^\d{5}(-\d{4})?$/;
const ADDRESS_RE = /^\d+\s+\w+.*(st|ave|dr|ln|blvd|ct|rd|way|street|avenue|drive|lane|boulevard|court|road|circle)\b/i;

// Embedded patterns for compound text like "DOB: 01/15/1945" or "MBI 1A23B45C678".
// Replace the sensitive value in-place so the label is preserved and nothing leaks.
const EMBEDDED_RES = [
  { re: /[^\s@]+@[^\s@]+\.[^\s@]+/g, fn: spoofEmail },
  { re: /\(?\d{3}\)?[\s.-]+\d{3}[\s.-]+\d{4}/g, fn: spoofPhone },
  { re: /\b\d{3}-\d{2}-\d{4}\b/g, fn: spoofSsn },
  { re: /\b\d{2}-\d{7}\b/g, fn: spoofTin },
  { re: /\b[12]\d{9}\b/g, fn: spoofNpi },
  { re: /\b[0-9][A-Z][A-Z0-9]{2}-?[A-Z0-9]{3}-?[A-Z0-9]{4}\b/gi, fn: spoofMbi },
  { re: /\b\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}\b/g, fn: spoofDate },
  { re: /\b\d{4}-\d{2}-\d{2}\b/g, fn: spoofDate },
  { re: /\b\w{3}\s+\d{1,2},?\s+\d{4}\b/g, fn: spoofDate },
];

// Apply embedded value scrubbing (dates/phones/MBI/email) AND learned name-token
// substitution to arbitrary free text. Used for compound labels and AI narrative.
function transformFreeText(text) {
  let result = text;
  for (const { re, fn } of EMBEDDED_RES) {
    result = result.replace(re, (m) => fn(djb2(m)));
  }
  result = applyNameTokens(result);
  return result;
}

// Person-name shapes we trust enough to LEARN tokens from (so the same name is
// spoofed consistently wherever else it appears, including free text).
// Allow internal apostrophes/hyphens and all-caps so "McDonald", "O'Brien",
// "JAMES CHEN" are recognized (and learned) rather than partially leaked.
const LAST_FIRST_RE = /^([A-Z][A-Za-z'’-]+),\s*([A-Z][A-Za-z'’-]+)\b/;
const TITLE_SURNAME_RE = /^((?:Dr|Mr|Mrs|Ms|Doctor|Prof)\.?)\s+([A-Z][A-Za-z'’-]+)$/;
const FIRST_LAST_RE = /^([A-Z][A-Za-z'’-]+)\s+([A-Z][A-Za-z'’-]+)$/;

function detectAndSpoof(text) {
  const trimmed = text.trim();
  if (!trimmed || trimmed === '—' || trimmed === '-' || trimmed === 'N/A') return text;

  const seed = djb2(trimmed);

  if (PHONE_RE.test(trimmed)) return spoofPhone(seed);
  if (MBI_RE.test(trimmed)) return spoofMbi(seed);
  if (NPI_RE.test(trimmed)) return spoofNpi(seed);
  if (TIN_RE.test(trimmed)) return spoofTin(seed);
  if (SSN_RE.test(trimmed)) return spoofSsn(seed);
  if (EMAIL_RE.test(trimmed)) return spoofEmail(seed);
  if (ZIP_RE.test(trimmed)) return spoofZip(seed);
  if (DATE_RE.test(trimmed)) return spoofDate(seed);
  if (ADDRESS_RE.test(trimmed)) return spoofAddress(seed);

  // "Last, First" -- learn both tokens for consistent reuse elsewhere
  let m = trimmed.match(LAST_FIRST_RE);
  if (m) return spoofPersonLastFirst(m[1], m[2]);

  // "Dr. Surname" / "Mr. Surname" -- learn the surname
  m = trimmed.match(TITLE_SURNAME_RE);
  if (m) return `${m[1]} ${fakeForToken(m[2], 'last')}`;

  // Short text (likely a name or identifier) -- spoof as name-ish
  if (trimmed.length <= 60) {
    // If it looks like an org/practice (contains medical/health keywords or multiple words with caps)
    if (/\b(pharmacy|rx|drug)\b/i.test(trimmed)) {
      return pick(PHARMACY_NAMES, seed);
    }
    if (/\b(hospital|regional|medical center)\b/i.test(trimmed)) {
      return pick(FACILITY_NAMES, seed);
    }
    if (/\b(medical|health|clinic|care|practice|group|center|associates|partners|family|primary)\b/i.test(trimmed)) {
      return pick(PRACTICE_NAMES, seed);
    }
    if (/\b(ACO|MSSP|contract|managed|risk|track)\b/i.test(trimmed)) {
      return pick(CONTRACT_NAMES, seed);
    }
    if (/\b(aetna|cigna|humana|united|anthem|blue|shield|molina|centene|wellcare|medicare|medicaid)\b/i.test(trimmed)) {
      return pick(PAYER_NAMES, seed);
    }
    if (/\b(network|alliance|collaborative|systems|vytalize|privia|agilon|aledade|oak\s*street|chenmed)\b/i.test(trimmed)) {
      return pick(TENANT_NAMES, seed);
    }
    // "First Last" -- learn BOTH tokens. Must run before the generic free-text
    // transform: otherwise, once one token (e.g. a surname) is already known, the
    // transform would replace just that token and return early, leaking the other
    // (e.g. "Dominick Basile" -> "Dominick <fake>" with the first name intact).
    m = trimmed.match(FIRST_LAST_RE);
    if (m) return spoofPersonFirstLast(m[1], m[2]);
    // Compound/embedded values ("DOB: 01/15/1945") or a learned name inside other
    // short text -- scrub in place.
    const transformed = transformFreeText(trimmed);
    if (transformed !== trimmed) return transformed;
    // Single word (e.g. a standalone first or last name column) -- one fake name
    if (!/\s/.test(trimmed)) {
      return pick(seed % 2 === 0 ? FIRST_NAMES : LAST_NAMES, seed);
    }
    // Generic short text -- treat as a person name
    return `${pick(FIRST_NAMES, seed)} ${pick(LAST_NAMES, seed >> 4)}`;
  }

  // Long free text: scrub embedded values AND replace any already-learned name
  // tokens (AI narrative). If nothing matched yet, return null to blur; a later
  // rescan re-evaluates once names are learned.
  const transformed = transformFreeText(trimmed);
  return transformed !== trimmed ? transformed : null;
}

// Conservative detector for document-wide attribute scrubbing. Unlike
// detectAndSpoof (which assumes its input IS sensitive and falls back to inventing
// a fake person name for any short string), this only transforms when a concrete
// PHI pattern, a confident name shape, or an already-learned name token is present.
// Generic UI chrome ("Sort ascending", "Close", "Filter") is returned UNCHANGED so
// we don't turn every tooltip in the app into a fake patient name. Never returns
// null -- when nothing matches, the original is preserved.
function spoofKnownPhi(text) {
  const trimmed = text.trim();
  if (!trimmed) return text;

  const seed = djb2(trimmed);

  if (PHONE_RE.test(trimmed)) return spoofPhone(seed);
  if (MBI_RE.test(trimmed)) return spoofMbi(seed);
  if (NPI_RE.test(trimmed)) return spoofNpi(seed);
  if (TIN_RE.test(trimmed)) return spoofTin(seed);
  if (SSN_RE.test(trimmed)) return spoofSsn(seed);
  if (EMAIL_RE.test(trimmed)) return spoofEmail(seed);
  if (ZIP_RE.test(trimmed)) return spoofZip(seed);
  if (DATE_RE.test(trimmed)) return spoofDate(seed);
  if (ADDRESS_RE.test(trimmed)) return spoofAddress(seed);

  // Only the comma form ("Smith, John") and titled form ("Dr. Smith") are
  // name-specific enough to spoof on sight document-wide. We deliberately do NOT
  // run the bare "First Last" shape here: ordinary two-word UI chrome ("Sort
  // Ascending", "Export Data", "Pin Column") matches it and would be turned into
  // fake names. A genuine bare first-last name still gets caught below via the
  // learned-token path once those tokens are seen in a .sensitive field.
  let m = trimmed.match(LAST_FIRST_RE);
  if (m) return spoofPersonLastFirst(m[1], m[2]);
  m = trimmed.match(TITLE_SURNAME_RE);
  if (m) return `${m[1]} ${fakeForToken(m[2], 'last')}`;

  // Embedded PHI ("Claim Date: ... | NPI: 1234567890 | TIN: 12-3456789") or an
  // already-learned name appearing inside otherwise-generic text.
  const t = transformFreeText(trimmed);
  return t !== trimmed ? t : text;
}

// Deterministic spoof of a single free-text string for non-DOM consumers (chart
// data, canvas labels). Shares the same name-token map as the DOM engine so a real
// name maps to the SAME fake everywhere. Falls back to detectAndSpoof's full
// behavior (including inventing a name) since callers pass values they KNOW are
// sensitive (entity/provider/practice names feeding a chart).
export function spoofText(str) {
  if (str == null) return str;
  const text = String(str);
  if (!text.trim()) return text;
  try {
    const out = detectAndSpoof(text);
    return out === null ? '' : out;
  } catch {
    return '';
  }
}

// --- DOM processing ---

const originals = new WeakMap();

// Loop-breaker: spoofing is deterministic, so the observer firing on our own DOM
// writes must not cause us to re-spoof our output (which would produce
// spoof(spoof(x)) -- a different value each pass -- and cycle endlessly). We track
// provenance PER ELEMENT/NODE: each entry records the exact `spoofed` string we
// wrote. When we re-process, if the current text equals what we wrote for THIS
// element, it's our own output and we leave it untouched. (An earlier design used
// a single global set of every emitted value, but because the fakes are realistic
// names from small pools, a real value could collide with some other field's fake
// and be skipped -- leaking real PHI. Per-element provenance has no such collision
// and does not grow without bound.)
const rescanList = new Set();

// Attributes that can carry real data to the user (tooltips, screen readers,
// truncation hovers, autofilled inputs).
const SENSITIVE_ATTRS = ['title', 'aria-label', 'alt', 'placeholder'];

// Scrub leaking attributes. Skips an attribute only when its current value is
// exactly the spoof we last wrote for THIS element. `conservative` picks the
// detector: false (for .sensitive elements) assumes the value is PHI and spoofs
// aggressively; true (for document-wide scanning) only touches recognizable PHI so
// app chrome tooltips are left intact.
function scrubAttrs(el, entry, conservative) {
  if (!entry.attrs) entry.attrs = {};
  for (const attr of SENSITIVE_ATTRS) {
    if (!el.hasAttribute(attr)) continue;
    const current = el.getAttribute(attr);
    if (!current || !current.trim()) continue;
    const rec = entry.attrs[attr];
    if (rec && current === rec.spoofed) continue; // our own output
    const spoofed = conservative
      ? spoofKnownPhi(current)
      : detectAndSpoof(current);
    const value = spoofed === null ? '' : spoofed;
    // In conservative (document-wide) mode, skip untouched chrome entirely so we
    // don't track originals/data-spoofed on elements we never changed.
    if (conservative && value === current) continue;
    entry.attrs[attr] = { original: current, spoofed: value };
    el.setAttribute(attr, value);
  }
}

// Scrub leaking attributes + input values for a .sensitive element.
function processAttributes(el, entry) {
  scrubAttrs(el, entry, false);
  if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
    const current = el.value;
    const rec = entry.attrs.__value;
    if (current && current.trim() && !(rec && current === rec.spoofed)) {
      const spoofed = detectAndSpoof(current);
      const value = spoofed === null ? '' : spoofed;
      entry.attrs.__value = { original: current, spoofed: value };
      el.value = value;
      el.setAttribute('autocomplete', 'off');
    }
  }
}

// Blur fallback for text we cannot safely spoof. A plain CSS blur is partially
// legible when a viewer zooms or pauses a high-res recording, so we also drop the
// glyphs to transparent and replace them with a heavy text-shadow smudge -- a
// redaction with no recoverable characters, not a soft blur.
function applyBlur(el) {
  el.style.filter = 'blur(10px)';
  el.style.color = 'transparent';
  el.style.textShadow = '0 0 14px rgba(31, 41, 55, 0.9)';
  el.style.userSelect = 'none';
}

function clearBlur(el) {
  el.style.filter = '';
  el.style.color = '';
  el.style.textShadow = '';
  el.style.userSelect = '';
}

function processElement(el) {
  // Never let one bad element abort the whole batch (which would leave the
  // observer disconnected and PHI flowing). Swallow and move on.
  try {
    processElementUnsafe(el);
  } catch {
    /* ignore */
  }
}

// CSS selector for elements that can leak PHI through an attribute regardless of
// whether they are tagged `.sensitive` (e.g. an ag-grid cell's :title or an icon's
// aria-label). Scanned document-wide.
const ATTR_SELECTOR = SENSITIVE_ATTRS.map((a) => `[${a}]`).join(',');

function hasSensitiveAttr(el) {
  for (const attr of SENSITIVE_ATTRS) {
    if (el.hasAttribute?.(attr)) return true;
  }
  return false;
}

// Document-wide attribute-only scrubbing for elements that are NOT .sensitive
// (those are handled by processElement, which scrubs attrs aggressively). We only
// touch recognizable PHI here so app chrome is preserved.
function processAttrElement(el) {
  try {
    if (el.classList?.contains('sensitive')) return; // handled by processElement
    const entry = originals.get(el) || {};
    scrubAttrs(el, entry, true);
    if (entry.attrs && Object.keys(entry.attrs).length > 0) {
      originals.set(el, entry);
      el.setAttribute('data-spoofed', '');
    }
  } catch {
    /* ignore */
  }
}

function processAllAttributes() {
  document.querySelectorAll(ATTR_SELECTOR).forEach(processAttrElement);
}

function processElementUnsafe(el) {
  const entry = originals.get(el) || {};
  const children = el.children;
  const original = el.textContent;
  const hasText = original && original.trim();

  // Opt-in hard blur: a `.sensitive` element marked `data-demo-blur` is always
  // blurred wholesale, never token-substituted. Use for unstructured LLM/PHI
  // prose (e.g. AI chart-biopsy narrative) where partial name substitution would
  // still leak nicknames, locations, and other free-form PHI.
  if (hasText && el.hasAttribute('data-demo-blur')) {
    if (entry.type !== 'blur') {
      applyBlur(el);
    }
    entry.type = 'blur';
    entry.original = original;
    processAttributes(el, entry);
    originals.set(el, entry);
    el.setAttribute('data-spoofed', '');
    return;
  }

  if (!hasText) {
    // No body text, but may still leak via attributes (e.g. icon with title)
    if (!entry.type) entry.type = 'empty';
  } else if (children.length === 0) {
    // Skip only if the current text is exactly what we last wrote for THIS el.
    const isOurs =
      (entry.type === 'text' && original === entry.spoofed) ||
      (entry.type === 'blur' && original === entry.original);
    if (!isOurs) {
      const spoofed = detectAndSpoof(original);
      if (spoofed === null) {
        applyBlur(el);
        entry.type = 'blur';
        entry.original = original;
        entry.spoofed = undefined;
        rescanList.add(el); // a learned name may make this readable later
      } else {
        clearBlur(el);
        entry.type = 'text';
        entry.value = original;
        entry.spoofed = spoofed;
        el.textContent = spoofed;
        // Free-text blocks can pick up more name tokens learned later
        if (/\s/.test(original) && original.length > 20) rescanList.add(el);
        else rescanList.delete(el);
      }
    }
  } else {
    // Walk text nodes in mixed-content elements. Rebuild the node list each pass
    // so detached nodes (ag-grid reuse) drop out instead of accumulating.
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    const byNode = new Map((entry.nodes || []).map((r) => [r.node, r]));
    const present = [];
    let node;
    while ((node = walker.nextNode())) {
      const cur = node.textContent;
      if (!cur.trim()) continue;
      let rec = byNode.get(node);
      if (rec && cur === rec.spoofed) {
        present.push(rec); // our own output -- leave it
        continue;
      }
      // `cur` is real (new content or a Vue revert to original)
      const spoofed = detectAndSpoof(cur);
      if (!rec) rec = { node, original: cur };
      else rec.original = cur;
      if (spoofed !== null && spoofed !== cur) {
        node.textContent = spoofed;
        rec.spoofed = spoofed;
      } else {
        rec.spoofed = undefined;
      }
      present.push(rec);
    }
    if (present.length > 0) {
      entry.type = 'nodes';
      entry.nodes = present;
      rescanList.add(el);
    } else if (entry.type !== 'blur') {
      applyBlur(el);
      entry.type = 'blur';
    }
  }

  processAttributes(el, entry);
  originals.set(el, entry);
  el.setAttribute('data-spoofed', '');
}

function restoreElement(el) {
  const saved = originals.get(el);
  if (!saved) return;

  if (saved.type === 'text') {
    el.textContent = saved.value;
  } else if (saved.type === 'nodes') {
    for (const { node, original } of saved.nodes) {
      node.textContent = original;
    }
  } else if (saved.type === 'blur') {
    clearBlur(el);
  }
  if (saved.attrs) {
    for (const attr of SENSITIVE_ATTRS) {
      if (saved.attrs[attr]) el.setAttribute(attr, saved.attrs[attr].original);
    }
    if (saved.attrs.__value && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')) {
      el.value = saved.attrs.__value.original;
    }
  }
  el.removeAttribute('data-spoofed');
  originals.delete(el);
}

function processAll() {
  document.querySelectorAll('.sensitive').forEach(processElement);
}

// Re-apply spoofing to free-text elements now that more name tokens are known.
// Always recomputes from the stored ORIGINAL (never from current/already-spoofed
// text) so results stay deterministic and can't compound.
function rescanFreeText() {
  for (const el of rescanList) {
    if (!el.isConnected) {
      rescanList.delete(el);
      continue;
    }
    const entry = originals.get(el);
    if (!entry) {
      rescanList.delete(el);
      continue;
    }
    if (entry.type === 'blur') {
      const original = entry.original ?? el.textContent;
      const t = transformFreeText(original);
      if (t !== original) {
        clearBlur(el);
        entry.type = 'text';
        entry.value = original;
        entry.spoofed = t;
        el.textContent = t;
        rescanList.delete(el);
      }
    } else if (entry.type === 'text') {
      const t = detectAndSpoof(entry.value);
      if (t !== null && el.textContent !== t) {
        entry.spoofed = t;
        el.textContent = t;
      }
    } else if (entry.type === 'nodes' && entry.nodes) {
      for (const rec of entry.nodes) {
        if (!rec.node.isConnected) continue;
        const t = detectAndSpoof(rec.original);
        const out = t === null ? rec.original : t;
        if (rec.node.textContent !== out) {
          rec.spoofed = t === null ? undefined : out;
          rec.node.textContent = out;
        }
      }
    }
  }
}

// Run a rescan if names were learned, looping until the map stops growing
// (a rescan can itself learn names from short free-text nodes). Bounded.
function rescanIfLearned(versionBefore) {
  if (nameMapVersion === versionBefore) return;
  let guard = 0;
  let v;
  do {
    v = nameMapVersion;
    rescanFreeText();
  } while (nameMapVersion !== v && ++guard < 5);
}

function restoreAll() {
  // Every processed element (sensitive or attribute-only) carries data-spoofed.
  document.querySelectorAll('[data-spoofed]').forEach(restoreElement);
}

let observer = null;

const OBSERVE_OPTS = {
  childList: true,
  subtree: true,
  characterData: true,
  attributes: true,
  attributeFilter: SENSITIVE_ATTRS,
};

// Collect the elements affected by a batch of mutations. `sensitive` gets full
// element processing (text + attributes); `attrEls` gets document-wide
// attribute-only scrubbing (untagged elements whose title/aria-label/alt/
// placeholder changed or were inserted).
function collectTargets(mutations, sensitive, attrEls) {
  for (const m of mutations) {
    if (m.type === 'childList') {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1) {
          // Element node: itself and any sensitive descendants
          if (n.classList?.contains('sensitive')) sensitive.add(n);
          n.querySelectorAll?.('.sensitive').forEach((e) => sensitive.add(e));
          // Plus any attribute-bearing element in the inserted subtree
          if (hasSensitiveAttr(n)) attrEls.add(n);
          n.querySelectorAll?.(ATTR_SELECTOR).forEach((e) => attrEls.add(e));
        } else if (n.nodeType === 3) {
          // Text node inserted into an existing sensitive element
          const el = n.parentElement?.closest('.sensitive');
          if (el) sensitive.add(el);
        }
      }
    } else if (m.type === 'characterData') {
      const el = m.target.parentElement?.closest('.sensitive');
      if (el) sensitive.add(el);
    } else if (m.type === 'attributes') {
      if (m.target.classList?.contains('sensitive')) sensitive.add(m.target);
      else attrEls.add(m.target);
    }
  }
}

// MutationObserver callbacks run as a microtask BEFORE the browser paints, so
// processing here (rather than in a deferred rAF) replaces real data before it
// can flash on screen. We disconnect while applying our own DOM writes and drain
// the resulting records so we never re-process (and re-randomize) our own output.
function flush(mutations) {
  const sensitive = new Set();
  const attrEls = new Set();
  collectTargets(mutations, sensitive, attrEls);
  if (sensitive.size === 0 && attrEls.size === 0) return;
  observer.disconnect();
  // Always re-observe, even if processing throws -- otherwise the observer stays
  // disconnected and PHI renders unspoofed for the rest of the session.
  try {
    const version = nameMapVersion;
    sensitive.forEach(processElement);
    attrEls.forEach(processAttrElement);
    rescanIfLearned(version);
  } finally {
    observer.takeRecords();
    observer.observe(document.body, OBSERVE_OPTS);
  }
}

// Single source of truth for whether Demo Mode is active. App.vue keeps the
// reactive `demoMode` flag and this localStorage key in sync, so non-Vue modules
// (export utilities, etc.) can read the same state without a component context.
export function isDemoMode() {
  try {
    return localStorage.getItem('demoMode') === 'true';
  } catch {
    // If storage is unreachable we cannot prove demo mode is OFF -- fail closed.
    return true;
  }
}

// Export choke point: bulk file exports (CSV/XLSX/PDF) emit the RAW data model,
// which the on-screen DOM spoof engine never touches. There is no safe way to
// spoof an export on the fly, so exports are hard-blocked while Demo Mode is on.
// Call this at the top of every export entry point; returns true if the caller
// should abort.
export function exportBlockedInDemoMode() {
  if (!isDemoMode()) return false;
  if (typeof window !== 'undefined') {
    window.alert('Exports are disabled while Demo Mode is on.');
  }
  return true;
}

// Last-resort visual kill switch. If activation itself fails, we cannot prove any
// PHI is masked, so we blur the entire app and surface a loud alert rather than
// silently leaving real data on screen (fail closed, not open). Cleared on
// successful (re)activation and on deactivate.
function engageFailClosed() {
  document.body.classList.add('demo-mode-failed');
  if (typeof window !== 'undefined') {
    window.alert(
      'Demo Mode failed to initialize and the screen has been blurred. ' +
        'Do NOT share your screen. Reload the page to retry.'
    );
  }
}

export function activateSpoof() {
  if (observer) return; // already active -- don't orphan a second observer
  try {
    const version = nameMapVersion;
    processAll();
    processAllAttributes();
    rescanIfLearned(version);
    observer = new MutationObserver(flush);
    observer.observe(document.body, OBSERVE_OPTS);
    document.body.classList.remove('demo-mode-failed');
  } catch {
    // Activation threw before the observer was safely attached -- subsequent
    // renders would flow unspoofed. Tear down any partial state and fail closed.
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    engageFailClosed();
  }
}

export function deactivateSpoof() {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
  restoreAll();
  rescanList.clear();
  nameTokenMap.clear();
  nameTokenRegex = null;
  nameTokenDirty = false;
  nameMapVersion = 0;
  document.body.classList.remove('demo-mode-failed');
}
